import { useState } from "react";
import {
  AGENDA,
  AiEyebrow,
  Card,
  C,
  DELIVERABLES,
  FONT,
  SectionTitle,
} from "./shared";

export function MeetingPack() {
  const [status, setStatus] = useState("");
  const share = async () => {
    const summary =
      "CastPro negotiation pack: target $30.67/pc, walk-away $31.70/pc, Net 90 terms.";
    try {
      await navigator.clipboard.writeText(summary);
      setStatus("Pack summary copied to clipboard");
    } catch {
      setStatus("Pack summary ready to share");
    }
  };
  const generate = () => setStatus("Meeting pack generated successfully");
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 24,
        position: "relative",
      }}
    >
      <Card
        style={{
          borderLeft: `4px solid ${C.border2}`,
          padding: "20px 20px 20px 16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 16,
            flexWrap: "wrap",
          }}
        >
          <div>
            <strong style={{ fontSize: 18, color: C.ink2 }}>
              One-click meeting pack
            </strong>
            <div style={{ color: C.slate3, fontSize: 11, marginTop: 6 }}>
              EVH-4420-A3 · Housing Bracket · CastPro Industries · Fri 21 Aug
              2026 · 14:00 CET · Video · owner A. Mehta — Category Manager
            </div>
          </div>
          <span
            style={{
              border: `1px solid ${C.violet}`,
              borderRadius: 999,
              padding: "4px 9px",
              color: C.purple,
              fontSize: 10,
              fontWeight: 800,
              letterSpacing: 0.2,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            ✦ AI assembled
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 12,
            marginTop: 16,
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            onClick={generate}
            style={{
              height: 28,
              padding: "0 15px",
              border: "none",
              borderRadius: 15,
              background: `linear-gradient(90deg,${C.pinkGrad1},${C.pinkGrad2})`,
              color: C.white,
              cursor: "pointer",
              fontFamily: FONT,
              fontWeight: 700,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              gap: 5,
              justifyContent: "center",
            }}
          >
            Generate Pack
            <svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="m6 9 6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </button>
          <button
            type="button"
            onClick={share}
            style={{
              height: 28,
              padding: "0 14px",
              borderRadius: 15,
              border: `1px solid ${C.border}`,
              background: C.white,
              color: C.ink2,
              cursor: "pointer",
              fontFamily: FONT,
              fontWeight: 600,
              fontSize: 12,
              display: "flex",
              alignItems: "center",
              gap: 5,
              justifyContent: "center",
            }}
          >
            <svg viewBox="0 0 24 24" fill="none" width="14" height="14" style={{ color: "rgb(17, 24, 39)" }}><circle cx="18" cy="5" r="3" stroke="currentColor" stroke-width="1.8"></circle><circle cx="6" cy="12" r="3" stroke="currentColor" stroke-width="1.8"></circle><circle cx="18" cy="19" r="3" stroke="currentColor" stroke-width="1.8"></circle><path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4" stroke="currentColor" stroke-width="1.8"></path></svg>
            Share with negotiation team
          </button>
        </div>
      </Card>
      <Card
        style={{
          borderLeft: `4px solid ${C.purple2}`,
          padding: "20px 20px 20px 16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginBottom: 12,
          }}
        >
          <strong style={{ color: C.ink2 }}>Executive summary</strong>
          <span
            style={{
              color: C.purple,
              fontSize: 10,
              fontWeight: 600,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            Editable
          </span>
        </div>
        <p
          style={{ margin: 0, color: C.slate3, fontSize: 13, lineHeight: 1.55 }}
        >
          CastPro pricing on EVH-4420-A3 is{" "}
          <strong style={{ color: C.ink2 }}>9.4% above market benchmark</strong>
          , worth <strong style={{ color: C.ink2 }}>$76,250</strong> a year on
          this family and <strong style={{ color: C.ink2 }}>$1.2M</strong>{" "}
          across the category. The gap is concentrated in tooling amortisation,
          inbound freight and packaging — all evidence-backed and highly
          negotiable. Margin is inside the sector band and will be conceded only
          to buy the tooling correction. We will target{" "}
          <strong style={{ color: C.ink2 }}>$30.67/pc</strong> (-5.3%) with Net
          90 terms and returnable packaging, and will not settle above{" "}
          <strong style={{ color: C.ink2 }}>$31.70/pc</strong>, at which point
          the qualified alternate pays back within 14 months. Renewal notice
          must be served by <strong style={{ color: C.ink2 }}>2 October</strong>{" "}
          to keep that option live.
        </p>
      </Card>
      <Card
        style={{
          borderLeft: `4px solid ${C.purple2}`,
          padding: "20px 20px 20px 16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
          }}
        >
          <strong style={{ color: C.ink2 }}>AI-drafted opening script</strong>
          <span
            style={{
              border: `1px solid ${C.violet}`,
              borderRadius: 999,
              padding: "4px 9px",
              color: C.purple,
              fontSize: 10,
              fontWeight: 800,
              letterSpacing: 0.2,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
            }}
          >
            ✎ Editable
          </span>
        </div>
        <p
          style={{
            margin: "12px 0 0",
            color: C.slate3,
            fontSize: 13,
            lineHeight: 1.55,
          }}
        >
          "Thanks for making the time. Before we talk numbers — the volume
          outlook for this programme runs to 2029 and you are our first call on
          it. On price, our benchmark for EVH-4420-A3 at 25,000 pieces is{" "}
          <strong style={{ color: C.ink2 }}>$29.35</strong>. Your margin is
          inside the range we expect, so that is not where we want to spend the
          hour. Three items drive the gap: the die is quoted at $612k against a
          $480k benchmark and amortised over three years rather than five;
          inbound freight is billed at spot on a lane where our consolidated
          rate is 21% lower; and packaging is single-use where returnables pay
          back in nine months. Let us take them in that order — and in exchange
          for movement, we can talk payment terms and a twelve-month volume
          commitment."
        </p>
      </Card>
      <div
        style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 24 }}
        className="np-2col"
      >
        <Card>
          <SectionTitle size={15}>Meeting agenda</SectionTitle>
          <div style={{ marginTop: 16 }}>
            {AGENDA.map((row, index) => (
              <div
                key={index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "0.7fr 0.7fr 2fr",
                  gap: 10,
                  padding: "13px 0",
                  borderBottom:
                    index === AGENDA.length - 1
                      ? "none"
                      : `1px solid ${C.borderSoft}`,
                  fontSize: 12,
                }}
              >
                <span>{row[0]}</span>
                <strong>{row[1]}</strong>
                <span>{row[2]}</span>
              </div>
            ))}
          </div>
        </Card>
        <Card>
          <SectionTitle size={15}>Deliverables in the pack</SectionTitle>
          <div style={{ marginTop: 16 }}>
            {DELIVERABLES.map((row, index) => (
              <div
                key={index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1.4fr 0.5fr",
                  gap: 8,
                  padding: "13px 0",
                  borderBottom:
                    index === DELIVERABLES.length - 1
                      ? "none"
                      : `1px solid ${C.borderSoft}`,
                  fontSize: 12,
                }}
              >
                <strong>{row[0]}</strong>
                <span>{row[1]}</span>
                <span style={{ color: C.green3 }}>Ready</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
      {status && (
        <div
          role="status"
          style={{
            position: "fixed",
            bottom: 24,
            left: "50%",
            transform: "translateX(-50%)",
            background: C.deep,
            color: "#fff",
            padding: "10px 18px",
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          {status}
        </div>
      )}
    </div>
  );
}
